var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"aha-checkbox",class:[
    ("aha-checkbox--" + _vm.size),
    {
      'aha-checkbox--disabled': _vm.disabled,
      'aha-checkbox--checked': _vm.checked,
      'custom-mr-2': _vm.hasMarginRight,
    } ]},[(_vm.checked)?_c('i',{staticClass:"fa fa-check"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }